import flatMapDeep from "lodash/flatMapDeep";
import { useCallback, useMemo } from "react";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { useFetchContentList } from "@/hooks/useFetchContestList";

export const useContainer = () => {
  const { data, isLoading, mutate, size, setSize } = useFetchContentList();

  const items = useMemo(() => {
    return flatMapDeep(data?.map((item) => item.items) ?? []);
  }, [data]);

  const hasNext = useMemo(() => {
    return data?.[data.length - 1]?.hasNext ?? false;
  }, [data]);

  const onLoadNext = useCallback(() => {
    const lastData = data?.[data.length - 1];
    if (!lastData || !lastData.hasNext) return;

    setSize(size + 1);
  }, [data, setSize, size]);

  const handleOnRefresh = useCallback(() => {
    mutate();
  }, [mutate]);

  const [infiniteRef] = useInfiniteScroll({
    loading: isLoading,
    hasNextPage: hasNext,
    onLoadMore: onLoadNext,
  });

  return {
    items,
    showLoading: isLoading,
    hasNext,
    infiniteRef,
    handleOnRefresh,
  };
};
